import PropTypes from 'prop-types';
import { megaMenuListsPropTypes } from './components/MegaMenuLists/MegaMenuListsPropTypes';
import { megaMenuProductsPropTypes } from './components/MegaMenuProducts/MegaMenuProductsPropTypes';
export const megaMenuPropTypes = {
  items: PropTypes.shape({
    lists: megaMenuListsPropTypes.items,
    products: megaMenuProductsPropTypes.items
  }),
  mobilePreviousLayerLabel: PropTypes.string,
  isNavItemOpen: PropTypes.bool,
  classname: PropTypes.string
};